module.exports = __webpack_public_path__ + "media/images/front/toppage_cc_pc-c4b4af06fae3f313064a060d9da89127.png";